import { type ReactNode, type PointerEvent } from "react";
import { AlertDialog, AlertDialogContent, AlertDialogTitle, AlertDialogDescription, AlertDialogFooter, AlertDialogAction, type AlertDialogPropsType, AlertDialogCancel, AlertDialogCancelForAlert } from "@core/components/ui/AlertDialog";
import { cn } from "@core/utils/domUtil";

interface CustomAlertPropsType extends AlertDialogPropsType {
  /* CustomAlertPropsType: 앨럿 이름 */
  name: string;
  /* CustomAlertPropsType: 앨럿 열림 상태 */
  isOpen: boolean;
  /* CustomAlertPropsType: 앨럿 열림 상태 변경 시 호출 */
  onOpenChange?: (open: boolean) => void;
  /* CustomAlertPropsType: 앨럿 메시지 */
  children: ReactNode;
  /* CustomAlertPropsType: 확인 버튼 클릭 시 호출 */
  onClick?: (e: PointerEvent<HTMLButtonElement>) => void;
  /* CustomAlertPropsType: 앨럿 컨텐츠 클래스명 */
  contentClassName?: string;
}

export default function CustomAlert({ name, isOpen, onOpenChange, children, onClick, contentClassName, ...props }: CustomAlertPropsType) {
  const handleClick = (e: PointerEvent<HTMLButtonElement>) => {
    // close();
    onClick?.(e);
  };

  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange} data-name={name} {...props}>
      <AlertDialogContent data-name={name} className={cn(contentClassName)}>
        {/* AlertDialogTitle: 접근성 때문에 필요 */}
        <AlertDialogTitle className={cn("visible-hidden")}>Alert</AlertDialogTitle>
        <AlertDialogDescription>{children}</AlertDialogDescription>
        <AlertDialogFooter>
          <AlertDialogCancelForAlert onClick={handleClick}>확인</AlertDialogCancelForAlert>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
